import { mapDispatchToProps, mapStateToProps } from './SetupTOTP.container';

import AuthenticatorCode from '/b2b/common/components/AuthenticatorCode';
import { Box } from '@mui/material';
import { FormikTextField } from '/b2b/common/components/FormControls/TextField';
import FormikValidationForm from '/b2b/common/components/organisms/FormikValidationForm';
import PropTypes from 'prop-types';
import React from 'react';
import ReselectMFA from '../components/ReselectMFA';
import { connect } from 'react-redux';
import { setupTotpSchema } from './SetupTOTP.schema';

// eslint-disable-next-line no-use-before-define
export default connect(mapStateToProps, mapDispatchToProps)(SetupTOTP);

export function SetupTOTP(props) {
    const { verify } = props;
    return (
        <Box
            display="flex"
            flexDirection="column"
            height="100%"
            alignItems="stretch"
            justifyContent="center"
            sx={{ mx: 'auto', px: 2, maxWidth: 700, width: '100%', textAlign: 'center' }}
        >
            <FormikValidationForm
                initialValues={{ code: '' }}
                validationSchema={setupTotpSchema}
                onSubmit={verify}
                title="auth.amplify.mfa.setup.totp.title"
                submitText="auth.amplify.mfa.setup.submitText"
            >
                <Box
                    display="flex"
                    flexDirection="column"
                    width="100%"
                    flexGrow={1}
                    gap={0.5}
                    alignItems="center"
                    mt={4}
                    mb={1}
                    sx={theme => (theme.breakpoints.down('lg') ? { justifyContent: 'center' } : {})}
                >
                    <AuthenticatorCode />
                    <FormikTextField
                        name="code"
                        label="common.fields.code.label"
                        placeholder="auth.amplify.mfa.totp.placeholder"
                        fullWidth
                        required
                        mb={1}
                    />
                </Box>
            </FormikValidationForm>
            <ReselectMFA mfaType="auth.amplify.mfa.totp.title" />
        </Box>
    );
}

SetupTOTP.propTypes = {
    verify: PropTypes.func.isRequired,
};
